import { TimelineMax, Power3 } from 'gsap';

const InstagramRailPictureHover = (element) => {
  const picture = element.querySelector('.rail-picture__image-actual');

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .to(picture, 0.6, {
      scale: 1.2,
      transformOrigin: '50% 50%',
      ease: Power3.easeInOut,
    }, 'start');
  return tl;
};

export default InstagramRailPictureHover;
